import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';

export default function FormText(props) {
    return (
        <FloatingLabel label={props.label} className="mb-3">
            <Form.Control type="text" placeholder={props.label} {...props}/>
        </FloatingLabel>
    )
}